import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { DataService } from "../../services/data.service";
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'app-reportfake',
  templateUrl: './reportfake.component.html',
  styleUrls: ['./reportfake.component.scss']
})
export class ReportfakeComponent implements OnInit {
  loading = false;
  fakeForm = {};
  fakeProductReport = "";
  fakeProductAlert = false;

  constructor(
    private apiService: ApiService,
    private frontEndService: FrontEndService,
    private dataService: DataService,
    private stateService: StateService
  ) { }

  ngOnInit() {
  }

  reportFakeProduct() {
    
    this.fakeForm['user_id'] = this.dataService.userDetails['user_id'];
    // this.logService.printLog(this.fakeForm);
    this.loading = true;
    this.apiService.fakeProduct(this.fakeForm, (response) => {
      this.loading = false;
      // this.logService.printLog("Fake report - ", response ); 
      if(response.response == 'error') {
        this.fakeProductReport = response.message;
      }else {
        this.fakeProductReport = response.message;
        this.fakeProductAlert = true;
        this.fakeForm = {};
    }
    })
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/reportfake/reportfake.component.ts